import { connect } from 'react-redux';

import type { RootReducerStateT } from 'app/reducers/rootReducer';

import { OwnProps, Tags } from '../../components/modals/tags';

export type StateProps = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (_state: RootReducerStateT, ownProps: OwnProps) => ({
  initialValues: ownProps.node.payload || {},
});

export default connect(mapStateToProps)(Tags);
